import SVGPathDatas from '../SVGDatas/SVGPathDatas'
import arcToBezier from 'svg-arc-to-cubic-bezier'
const isRelative = command => relativeCommands.indexOf(command) !== -1

const relativeCommands = [
  'a',
  'c',
  'h',
  'l',
  'm',
  'q',
  's',
  't',
  'v',
]
const parseSVGPath = (_path, xoffset, yoffset, scale) => {
  xoffset = xoffset || 0
  yoffset = yoffset || 0
  scale = scale || 1
  const path = new SVGPathDatas()
  const formatedPath = _path.replace(/\s*([mlvhqcszaASMLVHQCZ])\s*/g, '\n$1 ')
    .replace(/,/g, ' ')
    .replace(/-/g, ' -')
    .replace(/ +/g, ' ')

  const strings = formatedPath.split('\n')
  const stringsLength = strings.length

  let x = 0
  let y = 0

  for (let s = 1; s < stringsLength; s++) {
    const instruction = strings[s].trim()
    const command = instruction.substring(0, 1)
    // if (op === 's' ) op = 'q'
    const terms = (instruction.length > 1 ? instruction.substring(2).trim().split(' ') : [])
    let termsLength
    const lowerCaseCommand = command.toLowerCase()
    const relative = isRelative(command)

    switch (lowerCaseCommand) {
      case 'm':
        x = (relative ? x : 0) + parseFloat(terms[0])
        y = (relative ? y : 0) + parseFloat(terms[1])
        if (s < stringsLength - 1) {
          const nextstring = strings[s + 1].trim()
          const nextCommand = nextstring.substring(0, 1).toLowerCase()
          if (!(nextCommand === 'm' || nextCommand === 'z')) {
            path.startShape()
            path.addPoint(x * scale + xoffset, y * scale + yoffset)
          }
        }
        break
      case 'l':
        termsLength = terms.length
        for (let t = 0; t < termsLength; t += 2) {
          x = (relative ? x : 0) + parseFloat(terms[t + 0])
          y = (relative ? y : 0) + parseFloat(terms[t + 1])
          path.addPoint(x * scale + xoffset, y * scale + yoffset)
        }
        break
      case 'v':

        terms.forEach(y2 => {
          y = (relative ? y : 0) + parseFloat(y2)
          path.addPoint(x * scale + xoffset, y * scale + yoffset)
        })
        break
      case 'h':
        terms.forEach(x2 => {
          x = (relative ? x : 0) + parseFloat(x2)
          path.addPoint(x * scale + xoffset, y * scale + yoffset)
        })
        break
      case 'q':
        termsLength = terms.length
        for (let q = 0; q < termsLength; q += 4) {
          const cx = (relative ? x : 0) + parseFloat(terms[q])
          const cy = (relative ? y : 0) + parseFloat(terms[q + 1])
          // processing has no quadratic curves, so we have to derive the cubic control points
          const cx1 = (x + cx + cx) / 3
          const cy1 = (y + cy + cy) / 3
          // make start point bezier if it differs from the control point
          if (x != cx1 || y != cy1) {
            path.setRightControl(cx1 * scale + xoffset, cy1 * scale + yoffset)
          }
          // NOTE: the relative quadratic instruction does not count control points as "real"
          // points, so the curve's on-curve coordinate is relative to the last on-curve one.
          x = (relative ? x : 0) + parseFloat(terms[q + 2])
          y = (relative ? y : 0) + parseFloat(terms[q + 3])
          // derive cubic control point 2
          const cx2 = (x + cx + cx) / 3
          const cy2 = (y + cy + cy) / 3
          path.addPoint(x * scale + xoffset, y * scale + yoffset)
          if (x != cx2 || y != cy2) { path.setLeftControl(cx2 * scale + xoffset, cy2 * scale + yoffset) }
        }
        break
      case 's':
        // this operation takes a series of [cx1 cy1 cx2 cy2 x2 y2] coordinates
        path.addPoint(x * scale + xoffset, y * scale + yoffset)
        // this operation takes a series of [cx cy x2 y2] coordinates
        termsLength = terms.length
        for (let q = 0; q < termsLength; q += 4) {
          const cx = (relative ? x : 0) + parseFloat(terms[q])
          const cy = (relative ? y : 0) + parseFloat(terms[q + 1])
          // processing has no quadratic curves, so we have to derive the cubic control points
          const cx1 = (x + cx + cx) / 3
          const cy1 = (y + cy + cy) / 3
          // make start point bezier if it differs from the control point
          if (x != cx1 || y != cy1) {
            path.setRightControl(cx1 * scale + xoffset, cy1 * scale + yoffset)
          }
          // NOTE: the relative quadratic instruction does not count control points as "real"
          // points, so the curve's on-curve coordinate is relative to the last on-curve one.
          x = (relative ? x : 0) + parseFloat(terms[q + 2])
          y = (relative ? y : 0) + parseFloat(terms[q + 3])
          // derive cubic control point 2
          const cx2 = (x + cx + cx) / 3
          const cy2 = (y + cy + cy) / 3
          path.addPoint(x * scale + xoffset, y * scale + yoffset)
          if (x != cx2 || y != cy2) { path.setLeftControl(cx2 * scale + xoffset, cy2 * scale + yoffset) }
        }
        break
      case 'c':
        termsLength = terms.length
        for (let c = 0; c < termsLength; c += 6) {
          // get first control point
          const cx1 = (relative ? x : 0) + parseFloat(terms[c])
          const cy1 = (relative ? y : 0) + parseFloat(terms[c + 1])
          // make start point bezier if it differs from the control point
          if (x != cx1 || y != cy1) {
            path.setRightControl(cx1 * scale + xoffset, cy1 * scale + yoffset)
          }
          // get second control point. NOTE: this is not relative to the first control point, but
          // relative to the on-curve start coordinate
          const cx2 = (relative ? x : 0) + parseFloat(terms[c + 2])
          const cy2 = (relative ? y : 0) + parseFloat(terms[c + 3])
          // NOTE: the relative cubic instruction does not count control points as "real"
          // points, so the curve's on-curve coordinate is relative to the last on-curve one.
          x = (relative ? x : 0) + parseFloat(terms[c + 4])
          y = (relative ? y : 0) + parseFloat(terms[c + 5])
          // add end point, make bezier if the on-curve and control point differ
          path.addPoint(x * scale + xoffset, y * scale + yoffset)
          if (x != cx2 || y != cy2) { path.setLeftControl(cx2 * scale + xoffset, cy2 * scale + yoffset) }
        }
        break
      case 'z':
        path.closeShape()
        if (s < stringsLength - 1) {
          const nextstring = strings[s + 1].trim()
          const nextCommand = nextstring.substring(0, 1).toLowerCase()
          if ((nextCommand === 'm')) {
            // console.log('reopen')
          }
        }
        break
      case 'a':
        const obj = {
          px: x,
          py: y,
          cx: parseFloat(terms[5]),
          cy: parseFloat(terms[6]),
          rx: parseFloat(terms[0]),
          ry: parseFloat(terms[1]),
          xAxisRotation: parseFloat(terms[2]),
          largeArcFlag: parseFloat(terms[3]),
          sweepFlag: parseFloat(terms[4]),
        }
        obj.cx = (relative ? x : 0) + obj.cx
        obj.cy = (relative ? y : 0) + obj.cy
        const curves = arcToBezier(obj)
        curves.forEach((c) => {
          const terms = [c.x1, c.y1, c.x2, c.y2, c.x, c.y]
          termsLength = terms.length
          for (let c = 0; c < termsLength; c += 6) {
            // get first control point
            const cx1 = parseFloat(terms[c])
            const cy1 = parseFloat(terms[c + 1])
            // make start point bezier if it differs from the control point
            // get second control point. NOTE: this is not relative to the first control point, but
            // relative to the on-curve start coordinate
            const cx2 = parseFloat(terms[c + 2])
            const cy2 = parseFloat(terms[c + 3])
            // NOTE: the relative cubic instruction does not count control points as "real"
            // points, so the curve's on-curve coordinate is relative to the last on-curve one.
            x = parseFloat(terms[c + 4])
            y = parseFloat(terms[c + 5])
            // add end point, make bezier if the on-curve and control point differ
            path.addPoint(x * scale + xoffset, y * scale + yoffset)
          }
        })
        break
    }
  }
  return path
}

export default parseSVGPath
